/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { css } from '@emotion/react';

export default function Arrow({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      css={{
        ...css`
          color: #3722d3;
          cursor: pointer;
        `,
        ...(props.css ? props.css : {}),
      }}
      {...props}
    >
      <rect x="3" y="8.5" width="13" height="2" fill="currentColor" />
      <path
        d="M7.4141 13.7426L3.17146 9.5L7.4141 5.25736"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
}

Arrow.propTypes = {
  css: PropTypes.instanceOf(css),
};
